import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multi-information-actions',
  templateUrl: './multi-information-actions.component.html',
  styleUrls: ['./multi-information-actions.component.scss']
})
export class MultiInformationActionsComponent implements OnInit {
  @Input() data: Object;
  Form: FormGroup;
  document: string;
  pdf64: string | ArrayBuffer;
  pdf: string = null;

  /* Modal cases
    1: name, orderId.
    2: startDate, endDate , name, totalOperationsByMonth
    3: idSoat, name , orderId, pdf, pdf64.
    4: information
   */
  constructor(private fb: FormBuilder,
              public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.Form = this.fb.group({
      id: [this.data['id'] || null],
      pdf: [this.data['url'] || null],
      pdf64: [this.data['pdf64'] || null],
      pdf64Upload: [this.data['url'] ? true : null],
      idSoat: [this.data['idSoat'] || null],
      information: [this.data['information'] || null],
      startDate: [this.data['startDate'] || null],
      endDate: [this.data['endDate'] || null],
      name: [this.data['name'] || null, Validators.required],
      orderId: [this.data['orderId'] || 1, Validators.required],
      totalOperationsByMonth: [this.data['totalOperationsByMonth'] || null]
    });
    this.caseValidator();
    if (this.data['url']) {
      this.document = this.Form.get('pdf').value;
    }
  }

  caseValidator(): void {
    switch (this.data['modal'].type) {
      case 2:
        this.Form.get('startDate').setValidators([Validators.required]);
        this.Form.get('endDate').setValidators([Validators.required]);
        this.Form.get('totalOperationsByMonth').setValidators([Validators.required]);
        this.Form.get('orderId').clearValidators();
        break;
      case 3:
        this.Form.get('idSoat').setValidators([Validators.required]);
        this.Form.get('pdf').setValidators([Validators.required]);
        /*this.Form.get('pdf64').setValidators([Validators.required]);*/
        this.Form.get('pdf64Upload').setValue(false);
        break;
      case 4:
        this.Form.get('orderId').setValidators([]);
        this.Form.get('name').setValidators([]);
        this.Form.get('information').setValidators([Validators.required]);
        break;
    }
  }

  file64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (pdf) => {
      this.pdf64 = pdf.target.result;
      this.pdf = event.target.files[0].name;
      this.Form.get('pdf').setValue((event.target.files[0]).name);
      if (typeof this.pdf64 === 'string') {
        this.Form.get('pdf64').setValue(this.pdf64.split(',')[1]);
      }
      this.Form.get('pdf64Upload').setValue(true);
    };
  };

  send(): void {
    const emitted = this.Form.value;
    for (const item in emitted) {
      if (emitted.hasOwnProperty(item) && emitted[item] === null) {
        delete emitted[item];
      }
    }

    this.activeModal.close(emitted);
  }

}
